import React from "react";
import { useState } from "react";

import { Form, Card, Dropdown, Button,Row, Col } from "react-bootstrap";
import { FaDownload, FaRedo, FaPaperPlane, FaArrowDown } from "react-icons/fa";
import '../css/main.css';

const AudioRedescribe = ({
  videoname, setVideoname,
  videoDescription, setVideoDescription,
  model, setModel,
  language, setLanguage,
  descriptionType, setDescriptionType,
  voice, setVoice,
  mediaFormats, mediaFormatError,
  toggleFormat,
  handleRedescribe,
  isRedescribing,
  progress,
  handleExport,
  redescribeVideodetails
}) => {
const [activeTab, setActiveTab] = useState("original");
console.log("redescribeVideodetails",redescribeVideodetails);
const sourceType = redescribeVideodetails?.data?.file?.source?.source;
const sourcePath = redescribeVideodetails?.data?.file?.source?.path;
console.log("sourceType",sourceType)
console.log("sourcePath",sourcePath)
const isLocalSource = sourceType === "local";
  const formats = [
    { label: "Text (Transcript)", value: "text" },
    { label: "Audio", value: "audio" },
    // { label: "Video (with Audio Description)", value: "video" },
  ];

  return (
//       <Card className="shadow-sm border-0 p-3 card-bgcolor">
//                 <Card.Title className="text-center mb-2">Audio Description Generator</Card.Title>
//                 <Form>
//                   <Form.Group className="mb-2">
//                     <Form.Label>Narrator</Form.Label>
//                      <Form.Select value={model} onChange={(e) => setModel(e.target.value)}>
//                     <option value="m1">Amrita Model 1</option>
//                     <option value="m2">Amrita Model 2</option>
//                     <option value="m3">Amrita Model 3</option>
//                     <option value="m4">Amrita Model 4</option>
//                   </Form.Select>
//                   </Form.Group>
    
//                   <Form.Group className="mb-2">
//                     <Form.Label>Language</Form.Label>
//                      <Form.Select value={language} onChange={(e) => setLanguage(e.target.value)}>
//                     <option value="en-US">English(US)</option>
//                     <option value="hi">Hindi</option>
//                   </Form.Select>
//                   </Form.Group>
    
//                   <Form.Group className="mb-2">
//                     <Form.Label>Description Type</Form.Label>
//                    <Form.Select value={descriptionType} onChange={(e) => setDescriptionType(e.target.value)}>
//                     <option value="Brief">Brief</option>
//                     <option value="Elaborate">Elaborate</option>
//                   </Form.Select>
//                   </Form.Group>
    
//                   <Form.Group className="mb-2">
//                     <Form.Label>Voice</Form.Label>
//                      <Form.Select value={voice} onChange={(e) => setVoice(e.target.value)}>
//                     <option value="Male">Male</option>
//                     <option value="Female">Female</option>
//                   </Form.Select>
//                   </Form.Group>
    
//                   <Form.Group className="mb-3">
//                     <Form.Label>Generate As</Form.Label>
                  
//                   <Form.Group className="text-center my-2">
//   <Row className="justify-content g-3">
//     {formats.map((format) => (
//       <Col
//         key={format.value}
//         xs={6}
//         sm={4}
//         md="auto"
//         className="d-flex justify-content-center"
//       >
//         <Form.Check
//           type="checkbox"
//           id={`media-${format.value}`}
//           label={format.label}
//           checked={
//             format.value === "video"
//               ? true
//               : mediaFormats.includes(format.value)
//           }
//           readOnly={format.value === "video"} // video always checked, not changeable
//           onChange={
//             format.value !== "video"
//               ? () => toggleFormat(format.value, "media")
//               : undefined
//           }
//           className={`medium ${
//             mediaFormatError && !mediaFormats.includes(format.value)
//               ? "border border-danger rounded-2 px-2 py-1"
//               : ""
//           }`}
//         />
//       </Col>
//     ))}
//   </Row>
// </Form.Group>

//                   </Form.Group>
    
//                   <div className="d-flex justify-content-between">
//                       <Button
                                     
//                     onClick={handleRedescribe}
//   className="flex-fill redescribe-btn me-2"
//                     disabled={isRedescribing}
//                   >
//                     {isRedescribing ? (
//                       <>
//                         <span
//                           className="spinner-border spinner-border-sm me-2"
//                           role="status"
//                           aria-hidden="true"
//                         ></span>
//                         Processing... {progress}%
//                       </>
//                     ) : (
//                       <>
//                         <FaRedo className="me-1" /> Redescribe
//                       </>
//                     )}
//                   </Button>

//                   {/* <Dropdown className="flex-fill">
//   <Dropdown.Toggle
//     className="w-100 export-btn"
//     disabled={mediaFormats.length === 0}
//   >
//     <FaDownload className="me-1" /> Export
//   </Dropdown.Toggle>

//   <Dropdown.Menu>
//     {mediaFormats.includes("text") && (
//       <Dropdown.Item onClick={() => handleExport("Text")}>
//         Export Text
//       </Dropdown.Item>
//     )}
//     {mediaFormats.includes("audio") && (
//       <Dropdown.Item onClick={() => handleExport("Audio")}>
//         Export Audio
//       </Dropdown.Item>
//     )}
//     {mediaFormats.includes("video") && (
//       <Dropdown.Item onClick={() => handleExport("Video")}>
//         Export Video
//       </Dropdown.Item>
//     )}
//   </Dropdown.Menu>
// </Dropdown>
//  */}

//                   </div>
//                 </Form>
                
//               </Card>
   <>
      <Card className="shadow-sm border-1 p-3 redescribe-div" 
       role="region" aria-labelledby="audiodescription_header">
        <Card.Title className="text-center mb-2" id="audiodescription_header">Audio Description Generator</Card.Title>

        <Form aria-describedby="form-help">
 <p id="form-help" className="visually-hidden">
        Use this form to generate audio description for the selected video.
      </p>
 {/* <Form.Group className="mb-2">
            <Form.Label>Titile</Form.Label>
                <Form.Control value={videoname}  reset error />

              </Form.Group> */}

 {/* <Form.Group className="mb-2">
            <Form.Label>Description</Form.Label>
                <Form.Control value={videoDescription}  reset error />

              </Form.Group> */}

          <Form.Group className="mb-2">
            <Form.Label htmlFor="narratorSelect">Narrator</Form.Label>
            {/* <Form.Select value={model} onChange={(e) => setModel(e.target.value)}>
              <option value="m1">Amrita Model 1</option>
              <option value="m2">Amrita Model 2</option>
              <option value="m3">Amrita Model 3</option>
              <option value="m4">Amrita Model 4</option>
            </Form.Select> */}
            <Form.Select
             id="narratorSelect"
  value={model} aria-label="Select Narrator Model"
  onChange={(e) => setModel(e.target.value)}
>
  {redescribeVideodetails?.data?.form_data?.model_choices?.[0]?.map((item, idx) => (
    <option key={idx} value={item.key}>
      {item.label}
    </option>
  ))}
</Form.Select>

          </Form.Group>

          <Form.Group className="mb-2">
            <Form.Label htmlFor="languageSelect">Language</Form.Label>
            <Form.Select  id="languageSelect" value={language} aria-label="Select Language"
            onChange={(e) => setLanguage(e.target.value)}>
              {/* <option value="en-US">English(US)</option>
              <option value="hi">Hindi</option> */}
                {redescribeVideodetails?.data?.form_data?.languages?.[0]?.map((lang, idx) => (
      <option key={idx} value={lang[0]}>
        {lang[1]}
      </option>
    ))}
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-2">
            <Form.Label htmlFor="descriptionTypeSelect">Description Type</Form.Label>
            <Form.Select id="descriptionTypeSelect" value={descriptionType} aria-label="Select Description Type"
            onChange={(e) => setDescriptionType(e.target.value)}>
              {/* <option value="Brief">Brief</option>
              <option value="Elaborate">Elaborate</option> */}
               {redescribeVideodetails?.data?.form_data?.description_types?.[0]?.map((item, idx) => (
      <option key={idx} value={item}>
        {item}
      </option>
    ))}
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-2">
            <Form.Label htmlFor="voiceSelect">Voice</Form.Label>
            <Form.Select value={voice} 
            id="voiceSelect"
             aria-label="Select Voice Gender"
            onChange={(e) => setVoice(e.target.value)}>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Generate As</Form.Label>

            <Form.Group className="text-center my-2">
              <Row className="justify-content g-3">
                {formats.map((format) => (
                  <Col
                    key={format.value}
                    xs={6}
                    sm={4}
                    md="auto"
                    className="d-flex justify-content-center"
                  >
                    <Form.Check
                      type="checkbox"
                      id={`media-${format.value}`}
                      label={format.label}
                      // checked={
                      //   format.value === "video"
                      //     ? true
                      //     : mediaFormats.includes(format.value)
                      // }
                      // readOnly={format.value === "video"}
                      // onChange={
                      //   format.value !== "video"
                      //     ? () => toggleFormat(format.value, "media")
                      //     : undefined
                      // }

                      checked={mediaFormats.includes(format.value)}
onChange={() => toggleFormat(format.value, "media")}

                      className={`medium ${
                        mediaFormatError && !mediaFormats.includes(format.value)
                          ? "border border-danger rounded-2 px-2 py-1"
                          : ""
                      }`}
                    />
                  </Col>
                ))}
              </Row>
            </Form.Group>
          </Form.Group>

          <div className="d-flex justify-content-between">
            <Button
              onClick={handleRedescribe}
              className="flex-fill redescribe-btn me-2"
              disabled={isRedescribing}
               aria-disabled={isRedescribing}
        aria-describedby="progressStatus"
            >
              {isRedescribing ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Processing... {progress}%
                </>
              ) : (
                <>
                  <FaRedo className="me-1" aria-hidden="true" /> Redescribe
                </>
              )}
            </Button>
          </div>
             {/* Screen reader progress */}
      <div id="progressStatus" className="visually-hidden">
        {isRedescribing
          ? `Processing in progress. ${progress} percent completed.`
          : "Ready to generate audio description."}
      </div>
        </Form>
      </Card>

      {/* ---------------- DOWNLOAD SECTION BELOW FORM ---------------- */}
      {isLocalSource && (

      <div className="mt-3 p-3 shadow-sm border rounded download-section" role="region"
    aria-labelledby="downloadSectionHeader">
        <h5 id="downloadSectionHeader" className="mb-3 text-center">Download </h5>

        <div className="d-flex justify-content-center gap-2 flex-wrap">
            <Button
              variant="success"
                      aria-label="Download uploaded video"
              onClick={() => handleExport("uploadedvideo")}
              className="px-2"
            >
              <FaDownload aria-hidden="true" className="me-1" />  Uploaded Video
            </Button><br></br>
          {mediaFormats.includes("text") && (
            <Button
              variant="primary"
              onClick={() => handleExport("Text")}
              className="px-2"
                        aria-label="Download transcript text file"

            >
              <FaDownload aria-hidden="true" className="me-1" />  Text (Transcript)
            </Button>
          )}

          {mediaFormats.includes("audio") && (
            <Button
              variant="info"
              onClick={() => handleExport("Audio")}
              className="px-2"
                        aria-label="Download audio description"

            >
              <FaDownload aria-hidden="true" className="me-1" />  Audio
            </Button>
          )}

          {/* {mediaFormats.includes("video") && (
            <Button
              variant="warning"
              onClick={() => handleExport("Video")}
              className="px-2"
                        aria-label="Download video with embedded audio description"

            >
              <FaDownload aria-hidden="true" className="me-1" />  Video with Audio Description
            </Button>


          )} */}

     
        </div>
      </div>

)}



      
      {/* -------------------------------------------------------------- */}
    </>
        
  );
};

export default AudioRedescribe;
